import React from 'react'
import { Link, Text } from 'pcln-design-system'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const UnderlineLink = styled(Link)`
  text-decoration: underline;
`

const SignInLink = ({ promptSignIn }) => {
  return (
    <UnderlineLink
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        promptSignIn()
      }}
    >
      <Text display='inline' fontWeight='bold'>
        Sign in
      </Text>
    </UnderlineLink>
  )
}

SignInLink.propTypes = {
  promptSignIn: PropTypes.func,
}

export default SignInLink
